import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Outlet, useLocation, useNavigate } from "react-router-dom";
import Home from "./Home";
import { Link } from "react-scroll";


export default function App() {
  return (<>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />} >
          <Route index element={<Home />} />

          <Route path="*" element={<NoMatch />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </>);
}

const Layout = () => {

  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {

  }, [location])

  const setRefTabParam = (key) => {
    const params = new URLSearchParams(location.search);
    params.set("ref", key);                          // nycklar: kakelugn, insatser, kaminer, vedspis, skorsten, skorstenrenovering
    navigate({ search: params.toString() }, { replace: true });
  };

  return (<>
    <section role="navigation">

      <nav>
        <ul>
          <li>
            <Link activeClass="flame" smooth spy to="nav">
              <i className="fa-solid fa-fire"></i>
            </Link>
          </li>
          <li>
            <Link activeClass="active" smooth spy to="start" hashSpy onClick={() => setRefTabParam("")}>Start</Link>
          </li>
          <li>
            <Link activeClass="active" smooth spy to="tjanster" hashSpy onClick={() => setRefTabParam("")}>Tjänster</Link>
          </li>
          <li className="dropdown">
            <Link activeClass="active" smooth spy to="referenser" hashSpy onClick={() => setRefTabParam("")} className="dropdowntrigger">Referenser</Link>
            <ul className="dropdown-menu">
              <li>
                <Link activeClass="active" smooth onClick={() => setRefTabParam("kakelugn")} to="referenser" >Kakelugnar</Link>
              </li>
              <li>
                <Link activeClass="active" smooth onClick={() => setRefTabParam("insatser")} to="referenser" >Insatskaminer</Link>
              </li>
              <li>
                <Link activeClass="active" smooth onClick={() => setRefTabParam("kaminer")} to="referenser" >Kaminer</Link>
              </li>
              <li>
                <Link activeClass="active" smooth onClick={() => setRefTabParam("vedspis")} to="referenser" >Bakugnar & vedspisar </Link>
              </li>
              <li>
                <Link activeClass="active" smooth onClick={() => setRefTabParam("skorsten")} to="referenser" >Skorstenar</Link>
              </li>
              <li>
                <Link activeClass="active" smooth onClick={() => setRefTabParam("skorstensrenovering")} to="referenser" >Skorstensrenovering</Link>
              </li>

            </ul>
          </li>
          <li>
            <Link activeClass="active" smooth spy to="offert" hashSpy onClick={() => setRefTabParam("")}>Offert</Link>
          </li>
          <li>
            <Link activeClass="active" smooth spy to="foretaget" hashSpy onClick={() => setRefTabParam("")}>Om oss</Link>

          </li>
        </ul>
      </nav>
    </section>
    
    <header className="intro" id="nav">

      <img src="/images/logo_i.png" alt="Haglunds kakelugnar och skorstenar" className="logo" />

      <div className="scrollToMain">
        <a className="fas fa-chevron-circle-down" onClick={() => {
          document.getElementById("main")?.scrollIntoView({ behavior: 'smooth' });
        }}></a>
      </div>

      <div className="videowrapper">
        <video autoPlay loop muted playsInline>
          <source src="/images/header.mp4" />
        </video>
      </div>

    </header>

    <main id="main">
      <Outlet />
    </main>
    <footer>

    </footer>
  </>);
}

const NoMatch = () => {
  return (
    <div>
      <h2>Nothing to see here!</h2>
      <p>
        <Link to="/">Go to the home page</Link>
      </p>
    </div>
  );
}